import { formatAttachments } from '../attachments/formatAttachments'
import moment from 'moment'

export function formatUser (user) {
  return {
    id: user.id,
    firstName: user.firstname,
    lastName: user.lastname
  }
}

export function formatGrade (grade) {
  return {
    id: grade.id,
    feedback: grade.feedback,
    score: grade.score
  }
}

export function formatAnswer (answer, grade) {
  console.log(answer)
  return {
    id: answer.id,
    user: formatUser(answer.user),
    body: answer.content.body,
    files: formatAttachments(answer.content.files.map(({ asset }) => asset)),
    grade: grade ? formatGrade(grade) : null,
    date: moment(answer.createdAt).format('MMM DD, YYYY'),
    timestamp: moment(answer.createdAt).format('HH:mm a'),
    sec: moment(answer.createdAt).format('ss')
  }
}

export function formatAnswerList (answers) {
  return answers.map(answer => {
    return {
      id: answer.id,
      title: answer.user.firstname + ' ' + answer.user.lastname,
      status: answer.status,
      date: moment(answer.createdAt).format('MMM DD, YYYY'),
      timestamp: moment(answer.createdAt).format('HH:mm a'),
      sec: moment(answer.createdAt).format('ss'),
      avatarUrl: answer.user.avatar_url,
      userInitials: answer.user.firstname[0] + answer.user.lastname[0]
    }
  })
}

export function formatAssignment (assignment) {
  return {
    id: assignment.id,
    title: assignment.question ? assignment.question.title : 'Untitled Assignment',
    question: {
      title: assignment.question ? assignment.question.title : 'Untitled Assignment',
      body: assignment.question ? assignment.question.body : '',
      attachments: assignment.question ? formatAttachments(assignment.question.files.map(({ asset }) => asset)) : []
    },
    date: moment(assignment.createdAt).format('MMM DD, YYYY'),
    timestamp: moment(assignment.createdAt).format('HH:mm a'),
    sec: moment(assignment.createdAt).format('ss')
  }
}

function getGrade (grade) {
  return {
    score: grade.score,
    feedback: grade.feedback
  }
}

export function formatResponderAssignment (assignment, grade) {
  return {
    id: assignment.id,
    title: assignment.question ? assignment.question.title : '',
    question: {
      title: assignment.question ? assignment.question.content.title : '',
      body: assignment.question ? assignment.question.content.body : '',
      attachments: assignment.question ? formatAttachments(assignment.question.content.files.map(({ asset }) => asset)) : []
    },
    answer: {
      id: assignment.content.id,
      body:
      assignment.content.body,
      attachments:
        formatAttachments(assignment.content.files.map(({ asset }) => asset))
    },
    grade: grade ? getGrade(grade) : null,
    status:
    assignment.status,
    date:
      moment(assignment.createdAt).format('MMM DD, YYYY'),
    timestamp:
      moment(assignment.createdAt).format('HH:mm a'),
    sec:
      moment(assignment.createdAt).format('ss')
  }
}

export function formatAuthorAssignmentList (assignments) {
  return assignments.map(assignment => {
    const subjectName = assignment?.lesson?.lessonplan?.template?.subject?.name || ''
    return {
      id: assignment.id,
      lessonPlanId: assignment?.lesson?.lessonplan?.template?.id,
      subject: assignment?.lesson?.lessonplan?.template?.subject?.name || '',
      lesson: assignment?.lesson?.lessonplan?.template?.lesson || '',
      title: assignment?.question?.title || `${subjectName} Assignment`,
      status: assignment.status,
      date: moment(assignment.createdAt).format('MMM DD, YYYY'),
      timestamp: moment(assignment.createdAt).format('HH:mm a'),
      sec: moment(assignment.createdAt).format('ss')
    }
  })
}

export function formatResponderAssignmentList (assignments) {
  return assignments.map(assignment => {
    const subjectName = assignment?.question?.lesson?.lessonplan?.template?.subject?.name || ''
    return {
      id: assignment?.id,
      lessonPlanId: assignment?.question?.lesson?.lessonplan?.template?.id,
      subject: subjectName,
      lesson: assignment?.question?.lesson?.lessonplan?.template?.lesson || '',
      title: assignment?.question?.content?.title || `${subjectName} Assignment`,
      status: assignment?.status,
      date: moment(assignment?.createdAt).format('MMM DD, YYYY'),
      timestamp: moment(assignment?.createdAt).format('HH:mm a'),
      sec: moment(assignment?.createdAt).format('ss')
    }
  })
}
